import React, { useRef } from 'react';
import { Provider } from 'react-redux';
import { createStore } from './createStore';
import { CustomerInformationContext } from './context/customerInformation';
import { StoreContext } from './context/store';
import { NTB_JOURNEY } from 'constants/general';
import { JourneyInformationHOC } from './components/JourneyInformationHOC/JourneyInformationHOC';
const store = createStore();

const CustomerInformationProvider = (props) => {
  const {
    bankId = 'CB',
    customerId = '',
    editablePaths = [],
    paasApiBaseUrl,
    libertyApiBaseiUrl,
    token = '',
    isSecondaryApplicant = false,
    userTrackingId = '',
    globalErrorAction = () => {},
    screenPaths = {},
    goToPath = () => {},
    journey = NTB_JOURNEY,
    isResume = false,
    cdnUrl = '',
    toggleBackButton = () => {},
    resumedCustomerData,
    brandId,
    authenticationUrl,
    sourceId,
    resumedCaseDetails,
    cicValue,
    resetCustomerInfo,
    setResetCustomerInfo
  } = props;

  const lazyStoreRef = useRef(null);

  const customerInformationContext = {
    customerId,
    bankId,
    editablePaths,
    token,
    isResume,
    paasApiBaseUrl,
    libertyApiBaseiUrl,
    isSecondaryApplicant,
    userTrackingId,
    globalErrorAction,
    screenPaths,
    goToPath,
    journey,
    isExisting: journey !== NTB_JOURNEY,
    cdnUrl,
    toggleBackButton,
    resumedCustomerData,
    brandId,
    authenticationUrl,
    sourceId,
    resumedCaseDetails,
    cicValue,
    resetCustomerInfo
  };

  // Checking for unexpected store changes
  if (process.env.NODE_ENV !== 'production') {
    if (lazyStoreRef.current && lazyStoreRef.current !== store) {
      console.warn('unexpected store change');
    }
  }

  // assigning lazy store ref
  lazyStoreRef.current = store;
  return (
    <CustomerInformationContext.Provider value={customerInformationContext}>
      <Provider context={StoreContext} store={store}>
        <JourneyInformationHOC
          journey={journey}
          resetCustomerInfo={resetCustomerInfo}
          setResetCustomerInfo={setResetCustomerInfo}
        >
          {props.children}
        </JourneyInformationHOC>
      </Provider>
    </CustomerInformationContext.Provider>
  );
};

export { CustomerInformationProvider };
